/**
 * Error parsing utilities for Experience API GraphQL errors
 *
 * The Experience API returns errors following the GraphQL spec with error codes
 * at `errors[].extensions.code` and user-facing messages at `errors[].message`.
 *
 * Error codes:
 * - INVALID_REQUEST: Client errors (invalid input, business rule violations)
 * - INTERNAL_SERVER_ERROR: Server-side errors
 */

/**
 * Parses a GraphQL/Apollo error to extract error code and message
 *
 * @param {Error} error - Apollo Client error object
 * @returns {{ code: string|null, message: string }}
 */
export function parseGraphQLError(error) {
  // Handle Apollo Client GraphQL errors
  if (error.graphQLErrors && error.graphQLErrors.length > 0) {
    const firstError = error.graphQLErrors[0];
    const code = firstError.extensions?.code || null;
    const message = firstError.message || "An unexpected error occurred.";
    return { code, message };
  }

  // Handle network errors
  if (error.networkError) {
    return {
      code: null,
      message: "Network error. Please check your connection and try again.",
    };
  }

  // Handle generic errors
  return {
    code: null,
    message: error.message || "An unexpected error occurred.",
  };
}
